import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import getCountyDiscretionaryTax from '../../src/modules/getCountyDiscretionaryTax';

const salesPriceSel = state => state.salestaxes.salesPrice;
const taxCountyFeeSel = state => state.salestaxes.taxCountyFee;

const selector = createSelector(
  [salesPriceSel, taxCountyFeeSel],
  (salesPrice, taxCountyFee) => {
    return precise(getCountyDiscretionaryTax(Number(salesPrice), Number(taxCountyFee)));
  },
);

export default selector;



// WEBPACK FOOTER //
// ./src/selectors/countyTaxTotal.selector.js